module.exports = __webpack_public_path__ + "img/snapchat-logo-gray.561fb3cb.svg";